import {
  DataTypeProvider,
  FilteringState,
  GroupingState,
  IntegratedFiltering,
  IntegratedGrouping,
  IntegratedSorting,
  IntegratedSummary,
  SortingState,
  SummaryState
} from "@devexpress/dx-react-grid";
import {
  DragDropProvider,
  Grid,
  GroupingPanel,
  Table,
  TableFilterRow,
  TableGroupRow,
  TableHeaderRow,
  TableSummaryRow,
  Toolbar,
  VirtualTable
} from "@devexpress/dx-react-grid-material-ui";
import { Theme, Typography, withStyles, WithStyles } from "@material-ui/core";
import { Paper } from "@meeva/ontheme/Container/Paper";
import classNames from "classnames";
import moment from "moment";
import { useEffect } from "react";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Movement } from "../app/AccountAnalyze";
import { currencyVal } from "../app/helper";
import { Direction } from "../db/AccountMovement";
import { useApp } from "../index";
import { AppState } from "../redux";
import ValueFormatterProps = DataTypeProvider.ValueFormatterProps;

export const columnDefs = [
  { title: "Saldo", name: "debit" },
  { title: "Haben", name: "credit" },
  { title: "Gegenkonto", name: "otherAccountNo" },
  { title: "Bezeichnung", name: "description" },
  { title: "Datum", name: "date" }
];
const tableColumnExtensions = [
  { columnName: "debit", align: "right" as "right", width: 90 },
  { columnName: "credit", align: "right" as "right", width: 90 },
  { columnName: "otherAccountNo", width: 100 }
];

const totalSummaryItems = [{ columnName: "debit", type: "sum" }, { columnName: "credit", type: "sum" }];

interface MatchParams {
  accountNo: string;
}

interface Props extends RouteComponentProps<MatchParams> {}
interface ConnectedProps {
  result: Movement[];
}

const styles = (theme: Theme) => ({
  paper: {
    height: "100%",
    background: "white",
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    display: "flex",
    flexDirection: "column" as "column"
  },
  chipContainer: {
    display: "flex",
    justifyContent: "center" as "center",
    flexWrap: "wrap" as "wrap"
  },
  chip: {
    margin: theme.spacing.unit
  }
});

const ConvertRow = (row: Movement) => ({
  id: row.meta.id,
  debit: row.side === Direction.Soll ? row.amount : null,
  credit: row.side === Direction.Haben ? row.amount : null,
  otherAccountNo: row.primary ? row.meta.source.contraAccountNumber : row.meta.source.sourceAccountNumber,
  description: row.meta.source.label,
  date: row.meta.source.date,
  primary: row.primary
});
// type RowType = ReturnType<typeof ConvertRow>;

type AllProps = Props & ConnectedProps & WithStyles<typeof styles>;

const Saldo = ({ value }: ValueFormatterProps) => {
  if (value === null) {
    return null;
  }
  return <>{currencyVal(value)}</>;
};
const Date = ({ value }: ValueFormatterProps) => <>{value && moment(value).format("DD.MM.YYYY")}</>;

const TableRow = ({ row, ...restProps }: Table.DataRowProps) => <VirtualTable.Row row={row} {...restProps} className={classNames({ primary: row.primary })} />;
const Cell = (props: Table.DataCellProps) => <VirtualTable.Cell {...props} className={props.column.name} />;
const Root = (props: Grid.RootProps) => <Grid.Root {...props} style={{ height: "100%" }} />;

// TODO: Refactor
// TODO: https://github.com/DevExpress/devextreme-reactive/issues/813#issuecomment-442863776

const AccountDetail = (props: AllProps) => {
  const accountNo = parseInt(props.match.params.accountNo, 10);
  const app = useApp();
  useEffect(() => {
    app.selectAccountData(accountNo);
  }, [accountNo]);

  const { classes } = props;
  return (
    <Paper className={classes.paper}>
      <Typography variant="h5">Konto-Details: {accountNo}</Typography>
      <div
        className="ag-theme-balham accountTable"
        style={{
          // height: "500px",
          flex: "1 1 300px",
          overflow: "hidden"
        }}
      >
        <Grid columns={columnDefs} rows={props.result.map(ConvertRow)} getRowId={row => row.id} rootComponent={Root}>
          <DragDropProvider />
          <SortingState />
          <IntegratedSorting />
          <FilteringState defaultFilters={[]} />
          <IntegratedFiltering />
          <GroupingState defaultGrouping={[{ columnName: "date" }]} />
          <SummaryState totalItems={totalSummaryItems} groupItems={totalSummaryItems} />
          <IntegratedGrouping />
          <IntegratedSummary />
          <DataTypeProvider formatterComponent={Saldo} for={["credit", "debit"]} />
          <DataTypeProvider formatterComponent={Date} for={["date"]} />
          <VirtualTable height="auto" rowComponent={TableRow} cellComponent={Cell} columnExtensions={tableColumnExtensions} />
          <TableHeaderRow showSortingControls />
          <TableFilterRow />
          <TableGroupRow showColumnsWhenGrouped />
          <Toolbar />
          <GroupingPanel />
          <TableSummaryRow />
        </Grid>
      </div>
    </Paper>
  );
};

export default withStyles(styles)(
  connect((state: AppState) => ({
    result: state.report.detail.result
  }))(AccountDetail)
);



// WEBPACK FOOTER //
// ./src/Detail/index.tsx